import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { OrganizationSignUpTermsOfServiceStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { useOrganizationSignUpTermsOfServiceController } from "../../hooks/useOrganizationSignUpTermsOfServiceController";
import { TermsOfServiceForm } from "../../../../authentication/components/TermsOfServiceForm";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { BackButton } from "./BackButton";
import REMAvatar from "../../../../../shared/modules/rem-conversion/components/Avatar";
import MdiIcon from "../../../../../components/Shared/MdiIcon";
import { mdiTextBoxSearchOutline } from "@mdi/js";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        alert: {
            marginBottom: theme.spacing(2),
            margin: 'auto',
            boxSizing: 'border-box',
            maxWidth: '500px',
            textAlign: 'left',
            flexGrow: 1
        },
        avatar: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            width: '75px',
            height: '75px',
            margin: '16px auto',
            marginTop: theme.spacing(4),
        },
        prompt: {
            marginTop: theme.spacing(2),
            color: theme.palette.action.active
        },
        instructions: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(-2)
        }
    })
);

export const OrganizationSignUpTermsOfServiceStep: React.FC<
    StepRenderProps<OrganizationSignUpTermsOfServiceStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useOrganizationSignUpTermsOfServiceController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            {controller.error
                ? <Alert severity="error" className={classes.alert}>
                    <AlertTitle>Registration Error</AlertTitle>
                    {controller.error}
                </Alert>
                : null
            }
            <REMAvatar className={classes.avatar}>
                <MdiIcon iconPath={mdiTextBoxSearchOutline} fontSize='large' />
            </REMAvatar>
            <div className={classes.prompt}>
                <Typography variant="h5">One last step!</Typography>
                <Typography className={classes.instructions}>Please review the Terms of Service for organization administrators.</Typography>
            </div>
            <TermsOfServiceForm
                values={controller.values}
                onChange={(patch) => {
                    controller.onChange(patch);
                    update(patch); // sync with Flow
                }}
                onSubmit={controller.onSubmit}
                isSubmitting={controller.isSubmitting}
                // error={controller.error}
                fieldErrors={controller.fieldErrors}
            />
            <BackButton
                onClicked={() => controller.onSubmit({ backClicked: true })}
                isSubmitting={controller.isSubmitting}
            />
        </Fragment >
    );
});